var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Allow Authorization"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleCloseModal.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://blogpfthumb-phinf.pstatic.net/MjAxOTA2MThfMjE2/MDAxNTYwODM2ODQ5MDk5.QteT5YL-OesHK0KxOdLg_5sTkIOvAqT10uVjT8rdNrsg.IIvp-gexFczdgl3bbJL4riqyDoTLAJkXOSSbfJEB6JUg.PNG.blogpeople/%255BTeamBlog%255DProfile%25402x.png?type=s1",
                              alt: "Naver blog",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("네이버 블로그")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Trending")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch1",
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch1" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("My Subscriptions")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch2",
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch2" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [_c("span", [_vm._v("Everything")])]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch3",
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch3" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [_c("span", [_vm._v("Data type")])]),
                        _vm._v(" "),
                        _c("dd", [
                          _c("select", { staticClass: "go-form-control" }, [
                            _c("option", { attrs: { selected: "" } }, [
                              _vm._v("Select Data Type"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("Document (doc, docx…)"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v("Excel (xlsx, csv…)"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "3" } }, [
                              _vm._v("Presentation (pptx…)"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "4" } }, [
                              _vm._v("PDF files"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "5" } }, [
                              _vm._v("HTML"),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Sample Input",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-form-group" }, [
                        _c("select", { staticClass: "go-form-control" }, [
                          _c("option", { attrs: { selected: "" } }, [
                            _vm._v("Select your channel"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v("Channel 1"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v("Channel 2"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "3" } }, [
                            _vm._v("Channel 3"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "4" } }, [
                            _vm._v("Channel 4"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "5" } }, [
                            _vm._v("Etc"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-block-between" }, [
                          _c("label", { staticClass: "go-form-label" }, [
                            _vm._v("Input URL"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch4",
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch4" },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Enter an URL...",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn go-btn-outline-primary",
                                attrs: { type: "button" },
                              },
                              [
                                _c("i", {
                                  staticClass: "go-icon-18 go-icon-plus",
                                }),
                                _vm._v(
                                  "\n                      Add\n                    "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c("div", { staticClass: "go-form-feedback-help" }, [
                            _vm._v(
                              "Your verification code has been successfully verified."
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Enter an URL...",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group-append" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn go-btn-outline-primary",
                                attrs: { type: "button" },
                              },
                              [
                                _c("i", {
                                  staticClass: "go-icon-18 go-icon-plus",
                                }),
                                _vm._v(
                                  "\n                      Add\n                    "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c("div", { staticClass: "go-form-feedback-valid" }, [
                            _vm._v(
                              "Your verification code has been successfully verified."
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Enter search keyword...",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group-append" }, [
                            _c(
                              "div",
                              { staticClass: "custom-control custom-switch" },
                              [
                                _c("input", {
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    id: "customSwitch5",
                                  },
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  staticClass: "custom-control-label",
                                  attrs: { for: "customSwitch5" },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [_vm._v("This URL is invalid! Please try again.")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Sample Input",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c("div", { staticClass: "go-form-feedback-valid" }, [
                            _vm._v(
                              "Your verification code has been successfully verified."
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v("Back")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: { type: "button" },
                    },
                    [_vm._v("Next")]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }